import { render, staticRenderFns } from "./shipment-claim-input-case.vue?vue&type=template&id=2112b4a7&scoped=true&"
import script from "./shipment-claim-input-case.vue?vue&type=script&lang=js&"
export * from "./shipment-claim-input-case.vue?vue&type=script&lang=js&"
import style0 from "./shipment-claim-input-case.vue?vue&type=style&index=0&id=2112b4a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2112b4a7",
  null
  
)

export default component.exports